/*jslint browser: true */
/*global window:false, ko:false, $:false, AdminPhoto:false, overlayMedia:false */

;(function () {
    "use strict";

    window.ArticleTagsViewModel = function (options) {

        window.ObjectTagsViewModel.call(this, options);
        var model = this;

        var obj;
        obj = new TagObject();
        obj.id = options.article_id;
        obj.tags = options.article_tags || [];
        obj.edit_url = options.tagsEditUrl;

        model.object(obj);
        model.activeTags(obj.tags);
    };

    window.ArticleTagsViewModel.prototype = window.ObjectTagsViewModel;
})();